<template>
  <div class="container">
    <div class="container page_banner ">
      <div class='page_width'>
         <div class="banner_gruop" >
            <div class="banner_title"> <span class="color3"></span> Get in Touch</div>
            <div class="banner_tips mt-40 fw-300">We're here to help streamline your payment infrastructure and answer questions. Connect today to see how Corelinkpay can power your business.</div>
         </div>
       </div>
    </div>

     <div class="container"> 
      <div class="page_top" >
        <div class="page_width" >
          <div class="page_title">
            <div class="title_name color1">Let's Talk Business</div>
            <div class="title_tag color1">Merchant, developer, or partner—our team is ready. Discuss payment solutions, integrations, or support.</div>
          </div>
          <div class="cate_container">
              <div class="grid grid_md_gap grid_xs_gap">
                <div class="grid_md_4 grid_xs_12 grid_sm_12">
                    <div class="tab_left text-l border-card p-20 card_bg h-100p">
                        <div class="half_icon w-48px h-48px mb-10">
                          <img src="../../assets/image/tb40.png" alt="" class="">
                        </div>
                        <div class="half_title color1">For Businesses</div>
                        <div class="half_text color1 mt-10 fs-14 fw-300">Discover how Corelinkpay's payment tools boost efficiency and growth.</div>
                    </div>
                </div>
                <div class="grid_md_4 grid_xs_12 grid_sm_12">
                    <div class="tab_left text-l border-card p-20 card_bg h-100p">
                        <div class="half_icon w-48px h-48px mb-10">
                          <img src="../../assets/image/tb41.png" alt="" class="">
                        </div>
                        <div class="half_title color1">For Developers</div>
                        <div class="half_text color1 mt-10 fs-14 fw-300">Support for seamless API integration and technical queries.</div>
                    </div>
                </div>
                <div class="grid_md_4 grid_xs_12 grid_sm_12">
                    <div class="tab_left text-l border-card p-20 card_bg h-100p">
                        <div class="half_icon w-48px h-48px mb-10">
                          <img src="../../assets/image/tb42.png" alt="" class="">
                        </div>
                        <div class="half_title color1">For Partners</div>
                        <div class="half_text color1 mt-10 fs-14 fw-300">Explore collaboration opportunities to expand reach.</div>
                    </div>
                </div>
               
              </div>
          </div>
        </div>
      </div>
    </div>




    

    <div class="container"> 
      <div class="page_top" >
        <div class="page_width" >
            
          <div class="py-20">
              <div class="grid grid_md_gap grid_xs_gap" >
                
                <div class="grid_md_6 grid_xs_12 grid_sm_12 flex_col_start" >
                  <div class="page_title pb-30">
                      <div class="title_name color1 text-l">How to Reach Us</div>
                      <div class="title_tag color1 text-l">Simple and straightforward. Choose what works for you:</div>
                  </div>
                    <div class="tab_left text-l py-20   " >
                        <div class="half_title color1 flex_center_start"><img src="../../assets/image/tb43.png" alt="" class="w-40px h-40px mr-18">Email</div>
                        <div class="half_text color1  fs-14 fw-300">Drop us a message at business@corelinkpay.net for prompt assistance.</div>
                    </div>
                    <div class="tab_left text-l py-20 " >
                        <div class="half_title color1 flex_center_start"><img src="../../assets/image/tb44.png" alt="" class="w-40px h-40px mr-18">Phone</div>
                        <div class="half_text color1 fs-14 fw-300">Call our team at +86-18681451521 (Mon-Fri, 9 AM - 5 PM GMT).</div>
                    </div>
                    <!-- <div class="tab_left text-l p-20 h-100p  " >
                       <div class="half_title color1 flex_center_start"><img src="../../assets/image/tb45.png" alt="" class="w-40px h-40px mr-18">Live Chat</div>
                        <div class="half_text color1 mt-10 fs-14 fw-300"> Start a real-time conversation via our website for instant support.</div>
                    </div> -->
                    <!-- <div class="tab_left text-l py-20 h-100p  " >
                        <div class="half_title color1 flex_center_start">Visit Us</div>
                        <div class="half_text color1 fs-14 fw-300">Stop by our office to meet the team and see Corelinkpay in action.</div>
                    </div>
                    <div class="tab_left text-l py-20 h-100p  " >
                        <div class="half_title color1 flex_center_start">Visit Us</div>
                        <div class="half_text color1 fs-14 fw-300">Stop by our office to meet the team and see Corelinkpay in action.</div>
                    </div> -->
                    <div class="tab_left text-l py-20 " >
                        <div class="half_title color1 flex_center_start">Visit Us</div>
                        <div class="half_text color1 fs-14 fw-300">Stop by our office to meet the team and see Corelinkpay in action.</div>
                        <div class="half_text color1 mt-10 fs-14 fw-300">Address： UNIT 9 ON IST FLOOR THE CLOUD NO.111 TUNG CHAU STREET KL</div>
                    </div>
                    <div class="tab_left text-l py-20  " >
                        <div class="half_title color1 flex_center_start">Stay Connected</div>
                        <div class="half_text color1 fs-14 fw-300">Join our community and stay updated on payment innovation.</div>
                        <div class="half_text color1 mt-10 fs-14 fw-300">Newsletter： Tips, updates, and industry insights.  </div>
                        <div class="half_text color1 mt-10 fs-14 fw-300">Social Media： Follow us on X, LinkedIn, and Instagram.</div>
                        <div class="half_text color1 mt-10 fs-14 fw-300">Blog： Latest trends in fintech.</div>
                    </div>
                </div>
                <div class="grid_md_6 grid_xs_12 grid_sm_12 flex_center ">
                  <div class="border-card card_bg w-100p h-100p p-20">
                    <div class="tab_left text-l py-20 " >
                        <div class="half_title color1 flex_center_start">Send us a message</div>
                    </div>
                    <div class="tab_left text-l pb-20 " >
                        <div class="half_title color1 flex_center_start fw-300">Name</div>
                        <input v-model="name" class="h-40px"/>
                    </div>
                    <div class="tab_left text-l pb-20 " >
                        <div class="half_title color1 flex_center_start fw-300">Email</div>
                        <input v-model="email" class="h-40px"/>
                    </div>
                    <div class="tab_left text-l pb-20 " >
                        <div class="half_title color1 flex_center_start fw-300">Subject</div>
                        <input v-model="subject" class="h-40px"/>
                    </div>
                     <div class="tab_left text-l pb-20 " >
                        <div class="half_title color1 flex_center_start fw-300">Message</div>
                        <textarea  v-model="subject" class="py-20"></textarea>
                    </div>
                     <span class=" pointer color1 p-10 border-default mt-20 fs-f20 bg_3 dis-b" >Send Message</span>
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container"> 
      <div class="page_top" >
        <div class="page_width" >
           
         
           <div class="pt-20 pb-80">
              <div class="grid grid_md_gap grid_xs_gap">
                <div class="grid_md_6 grid_xs_12 grid_sm_12 flex_center">
                  <div class="w-100p">
                    <img src="../../assets/image/t59.png" alt="">
                  </div>
                </div>
                <div class="grid_md_6 grid_xs_12 grid_sm_12 flex_center">
                    <div class="page_title ">
                        <div class="title_name color1 text-l">Why Contact Corelinkpay?</div>
                        <div class="title_tag color1 text-l">More than a payment provider—we're your partner in building seamless financial infrastructure. Learn how our global solutions, AI-driven technology, and dedicated support can transform your business.</div>
                    </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
   
  
    
    

  
  </div>
</template>

<script>


export default {
    data(){
        return{
          name:'',
          email:'',
          subject:'',
          message:'',
        }
    }
}
</script>

<style lang="scss" scoped>
.page_banner{
    background-image:url( ../../../public/bg/bn_bg.png);
}

.title_line{
    width: 120px;
    position: relative;
    &::before{
        content:'';
        width: 20px;
        background:$theme_color3;
        position: absolute;
        right: -38px;
        height: 10px;
    }
}
.half_title{
   font-size: 30px;
}
.half_text{
   font-size: 18px;
}
input,textarea{
  background: #114D95;
  border-radius: 10px 10px 10px 10px;
  
  border:none;
  width: 100%;
  padding:0 20px;
  color:#fff;
  margin-top:10px;
}
textarea{
  height: 220px;
}

</style>